// frontend/src/components/Requisitions/edit/components/StatusHistory.jsx

import React from "react";

import { displayStatus, fmtDateTime } from "../utils";

export default function StatusHistory({ history }) {
  const rows = Array.isArray(history) ? history : [];

  return (
    <div className="mt-3">
      <div className="text-xs font-semibold text-gray-700 mb-2">
        Historial de estatus
      </div>

      {rows.length === 0 ? (
        <div className="text-sm text-gray-600">
          Aún no hay cambios de estatus registrados.
        </div>
      ) : (
        <div className="border rounded bg-white overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-2 py-2 text-left">Cuándo</th>
                <th className="px-2 py-2 text-left">Quién</th>
                <th className="px-2 py-2 text-left">Cambio</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id} className="border-t">
                  <td className="px-2 py-2">{fmtDateTime(row.changed_at)}</td>
                  <td className="px-2 py-2">
                    {row.changed_by_display || "Sistema"}
                  </td>
                  <td className="px-2 py-2">
                    {`${displayStatus(row.from_status || "—")} → ${displayStatus(row.to_status || "—")}`}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}